// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import { castToFloat } from 'helpers/reduxFormFunctions'
import makeATPC from './makeATPC'
import makeModulationConfigurations from './makeModulationConfigurations'

// if there's no radio id, there's no radio to defined.
// if there is, then prep that data for API.

// default value for r given here to support simplex paths

const formatRadio = (r = {}) => (
  !r.radioId
    ? ({
      acmCoordinationAdvantageFlag: false,
      atpc: null,
      coordinatedPower: null,
      radioFavoriteId: null,
      radioId: null,
      radioModulationConfigurations: [],
    }) : ({
      acmCoordinationAdvantageFlag: r.acmCoordinationAdvantageFlag,
      atpc: makeATPC(r.atpc),
      coordinatedPower: castToFloat(r.coordinatedPower),
      radioFavoriteId: r.radioFavoriteId,
      radioId: r.radioId,
      radioModulationConfigurations: makeModulationConfigurations(r.modulations, r.engineeringReference),
    })
)

export default formatRadio
